"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _prepareChildKeys = _interopRequireDefault(require("./prepareChildKeys"));

var _keyOrIndexToIndex = _interopRequireDefault(require("./keyOrIndexToIndex"));

var _move = _interopRequireDefault(require("unmutable/lib/move"));

var _swap = _interopRequireDefault(require("unmutable/lib/swap"));

var _default = function _default(swapOrMove) {
  var fn = swapOrMove === 'swap' ? _swap.default : _move.default;
  return function (keyA, keyB) {
    return function (parcelData) {
      var parcelDataWithChildKeys = (0, _prepareChildKeys.default)()(parcelData);
      var indexA = (0, _keyOrIndexToIndex.default)(keyA)(parcelDataWithChildKeys);
      var indexB = (0, _keyOrIndexToIndex.default)(keyB)(parcelDataWithChildKeys);

      if (typeof indexA === "undefined" || typeof indexB === "undefined") {
        return parcelData;
      }

      var value = parcelDataWithChildKeys.value,
          child = parcelDataWithChildKeys.child;
      return (0, _objectSpread2.default)({}, parcelDataWithChildKeys, {
        value: fn(indexA, indexB)(value),
        child: fn(indexA, indexB)(child)
      });
    };
  };
};

exports.default = _default;